<script setup lang="ts">
import { UiChip, UiIconButton, useToaster } from '@shopexperts/shared';
import { formatMetafieldReference } from '../../field-types';

const props = defineProps<{
  fieldKey: string;
}>();

const toaster = useToaster();

async function copyKey() {
  const value = formatMetafieldReference(props.fieldKey);
  try {
    if (!navigator.clipboard?.writeText) {
      throw new Error('Clipboard is unavailable.');
    }
    await navigator.clipboard.writeText(value);
    toaster.create({
      title: 'Metafield key copied',
      description: value,
      type: 'success',
    });
  } catch {
    toaster.create({
      title: 'Unable to copy metafield key',
      description: value,
      type: 'error',
    });
  }
}
</script>

<template>
  <span class="inline-flex min-w-0 items-center gap-1">
    <UiChip :text="formatMetafieldReference(props.fieldKey)" size="tag" variant="neutral" />
    <UiIconButton
      icon="copy"
      :aria-label="`Copy ${formatMetafieldReference(props.fieldKey)}`"
      variant="ghost"
      hover-style="highlight"
      class="h-7 w-7 shrink-0"
      @click="copyKey"
    />
  </span>
</template>
